import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Container, Card, CardHeader, CardContent, TextField, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers';
import { getUsers } from '../../users/store/userActions';
import { fDateYMD } from '../../../utils/formatTime';
import { getAuditBranches } from '../../branches/store/branchActions';
import { createAuditRecord } from '../store/auditActions';
import { Page } from '../../../components';
import { FormProvider, RHFSelect, RHFTextField } from '../../../components/hook-form';

const AuditForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { auditBranches } = useSelector((state) => state.branchReducer);
  const { users } = useSelector((state) => state.userReducer);
  console.log('STAFF LIST:', users);

  const { enqueueSnackbar } = useSnackbar();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const NewAuditSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string(),
    startDate: Yup.string(),
    endDate: Yup.string(),
    staffId: Yup.string(),
    branchId: Yup.number().required('Location is required'),
  });

  const defaultValues = {
    name: '',
    description: '',
    startDate: fDateYMD(startDate) || '',
    endDate: fDateYMD(endDate) || '',
    staffId: '',
    branchId: '',
  };

  const methods = useForm({
    resolver: yupResolver(NewAuditSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    // control,
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  console.log('VALUES:', values);

  useEffect(() => {
    dispatch(getAuditBranches({}));
    dispatch(getUsers({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectedLocation = (value) => {
    setValue('branchId', value);
  };
  const handleSelectedStaff = (value) => {
    console.log('STA:', value);
    setValue('staffId', value);
  };

  const onSubmit = async (data) => {
    const payload = {
      location_id: data.branchId,
      name: data.name,
      description: data.description,
      staff_id: data.staffId,
      start_date: fDateYMD(startDate),
      end_date: fDateYMD(endDate),
    };
    console.log('PAYLOAD:', payload);
    try {
      dispatch(createAuditRecord(payload));
      reset();
      enqueueSnackbar('Audit created successfully!');
      setTimeout(() => {
        navigate('/dashboard/audits');
      }, 2000); // 2000 mil
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Page title="Asset New Audit">
      <Container maxWidth="xl">
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Card sx={{ p: 3 }}>
            <CardHeader title="Create New Audit" />
            <CardContent>
              <Stack spacing={2}>
                <RHFTextField name="name" label="Audit Name" />
                <RHFTextField name="description" label="Description" />

                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  renderInput={(params) => <TextField {...params} />}
                />
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  renderInput={(params) => <TextField {...params} />}
                />

                {/* <Autocomplete
                  options={auditBranches || []}
                  getOptionLabel={(option) => option.name || ''}
                  value={selectedBranch}
                  onChange={(_, value) => {
                    setFormData((prev) => ({
                      ...prev,
                      branchId: value?.id || '',
                    }));
                  }}
                  renderInput={(params) => <TextField {...params} label="Branch" fullWidth required />}
                /> */}
                <RHFSelect
                  name="branchId"
                  label={
                    <span>
                      Location<span style={{ color: 'red' }}> *</span>
                    </span>
                  }
                  placeholder="Location"
                  onChange={(event) => handleSelectedLocation(event.target.value)}
                >
                  <option value="" />
                  {auditBranches?.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </RHFSelect>

                <RHFSelect
                  name="staffId"
                  label={
                    <span>
                      Assign<span style={{ color: 'red' }}> *</span>
                    </span>
                  }
                  placeholder="Assign"
                  onChange={(event) => handleSelectedStaff(event.target.value)}
                >
                  <option value="" />
                  {users?.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.display_name}
                    </option>
                  ))}
                </RHFSelect>

                {/* Uncomment if you want staff assignment */}

                {/* <Autocomplete
                  options={staffList || []}
                  getOptionLabel={(option) => option.display_name || ''}
                  value={selectedStaff}
                  onChange={(_, value) => {
                    setFormData((prev) => ({
                      ...prev,
                      staffId: value?.id || '',
                    }));
                  }}
                  renderInput={(params) => <TextField {...params} label="Assign Staff" fullWidth required />}
                /> */}

                <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                  <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                    Create Audit
                  </LoadingButton>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </FormProvider>
      </Container>
    </Page>
  );
};

export default AuditForm;
